// extracted by mini-css-extract-plugin
export default {"selector":"Routes_selector__2pv8o","newRouteBtn":"Routes_newRouteBtn__m02VW"};